import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { Redirect } from "react-router"
import { routePaths } from "../.."
import { failMessage } from "../../../Actions/Client/MessagesActions"
import { MemberSignUp } from "../../../Components/Views/Dashboard/Sections/Organization/MemberSignUp"
import { OrgRouteComponentProps } from "../../RouteProps"

export function MemberSignUpRoute({
    match,
    location
}: OrgRouteComponentProps<{ memberId: string }>) {
    const search = new URLSearchParams(location.search)
    const code = search.get("code")
    const memberId = Number.parseInt(match.params.memberId, 10)
    const dispatch = useDispatch()

    useEffect(() => {
        if (Number.isNaN(memberId) || code === null) {
            dispatch(failMessage("Sign up url is invalid"))
        }
    }, [code, dispatch, memberId])

    if (Number.isNaN(memberId) || code === null) {
        return <Redirect to={routePaths.home()} />
    }

    return (
        <MemberSignUp
            orgUsername={match.params.orgUsername}
            memberId={memberId}
            code={code}
        />
    )
}
